import { z } from "zod";
import { assetDocumentRelationships, type AssetDocumentRelationship } from "./vocabulary.js";
import { idempotencyKey } from "./requests.js";

export const assetDocumentMetadataFields = z.object({
  relationship: z.enum(assetDocumentRelationships),
  effectiveFrom: z.string().date().nullable(),
  expiresAt: z.string().date().nullable(),
});
export const assetDocumentMetadataBody = assetDocumentMetadataFields.extend({ idempotencyKey }).strict().refine(body => body.effectiveFrom === null || body.expiresAt === null || body.expiresAt >= body.effectiveFrom, { message: "Expiration cannot be before the effective date.", path: ["expiresAt"] });
export const assetDocumentTypeConfigBody = z.object({
  relationship: z.enum(assetDocumentRelationships),
  requiresExpiration: z.boolean(),
  idempotencyKey,
}).strict();
export interface AssetDocumentTypeConfig { relationship: AssetDocumentRelationship; requiresExpiration: boolean }
export interface AssetDocumentExpiry { expiresAt: string | null; daysUntilExpiry: number | null }
/** Fleet calendar dates, independent of the browser's timezone. */
export function assetDocumentExpiry(expiresAt: string | null, today: string): AssetDocumentExpiry {
  return { expiresAt, daysUntilExpiry: expiresAt === null ? null : Math.round((Date.parse(expiresAt + "T00:00:00Z") - Date.parse(today + "T00:00:00Z")) / 86400000) };
}
